import React from 'react'

import rehypeRaw from 'rehype-raw'
import ReactMarkdown from 'react-markdown'
import { useNavigate, useLocation } from 'react-router-dom'

import { RoutesNames } from '@/routes/routes'

import * as S from '../../styles'

export interface IStepButtonsProps {
  metadata: DoubtHelper
}
export const StepButton = ({ metadata }: IStepButtonsProps) => {
  const navigate = useNavigate()
  const location = useLocation()

  return (
    <S.ContainerBox data-testid="step-button-container">
      {metadata.title && (
        <>
          <S.Text variant="headline-h3" semiBold as="h3" color="typography">
            {metadata.title}
          </S.Text>
          <S.Space height={12} />
        </>
      )}

      <S.Text variant="body-3">
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{metadata.description}</ReactMarkdown>
      </S.Text>

      {metadata.buttonEnabled && (
        <>
          <S.Space height={24} />
          <S.Button
            variant="primary"
            color="primary"
            onClick={() =>
              navigate(RoutesNames.VARIABLE_INCOME, {
                state: location.state,
              })
            }
          >
            {metadata.buttonTitle}
          </S.Button>
        </>
      )}
    </S.ContainerBox>
  )
}
